import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-common-search-field',
  templateUrl: './common-search-field.component.html',
  styleUrls: ['./common-search-field.component.css']
})
export class CommonSearchFieldComponent implements OnInit {

  @Output() searchEvent = new EventEmitter<any>()

  constructor() { }

  ngOnInit(): void {
  }

  search(event : any){
    this.searchEvent.emit(event.target.value)
  }


}
